import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StudentsNavSquare from '../../components/StudentsNavSquare/StudentsNavSquare';
import styles from './StudentsNavGrid.module.scss';

export default class StudentsNavGrid extends Component {
  render() {
    const { projects } = this.props;

    return (
      <div className={styles.studentsNavGrid}>
        <header className={styles.header}>
          Type@Cooper West 2018 Graduates
        </header>
        <div className={styles.grid}>
          {projects.map(project => (
            <StudentsNavSquare
              name={project.node.frontmatter.designer}
              fontName={project.node.frontmatter.fontName}
              slug={project.node.fields.slug}
              key={project.node.fields.slug}
              activeFont={project.node.frontmatter.fonts[0].name}
              isSelected={project.isSelected}
            />
          ))}
        </div>
      </div>
    );
  }
};

StudentsNavGrid.propTypes = {
  projects: PropTypes.array
};



// WEBPACK FOOTER //
// ./src/components/StudentsNavGrid/StudentsNavGrid.jsx